<template>
    <div class="card mx-auto">
        <div class="card-header bg-primary text-white">
            <page-title :title="($t(titleKey))"></page-title>
        </div>

        <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
            <div class="form-inline pl-2 col-lg-6 col-md-12">

            </div>

            <div class="input-group col-lg-6 col-md-12">
                <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                <button type="button" class="btn btn-secondary" @click.stop="massSearch">
                    <i class="fas fa-search"></i>
                    {{ $t('buttons.search.btnText') }}
                </button>
                <button type="button" class="btn btn-secondary"
                        @click.stop="clearFilters">
                    <i class="fas fa-times"></i>
                    {{ $t('buttons.clearFilters.btnText') }}
                </button>
            </div>
        </div>

        <div class="card-body">
            <kendo-datasource ref="datasource1"
                                :transport="transportSettings"
                                :schema-model-id="'id'"
                                :schema-model-fields="schemaModelFields"
                                :schema-total="'count'"
                                :schema-data="'items'"
                                :page-size='defaultGridRows'
                                :server-paging="true"
                                :server-sorting="true"
                                :server-filtering="true"
                                :error="dataSourceError"
                                :requestEnd="datasorceRequestEnd">
            </kendo-datasource>

            <kendo-grid ref="grid"
                        id="grid"
                        :data-source-ref="'datasource1'"
                        :navigatable="gridOptions.navigatable"
                        :filterable="gridOptions.filterable"
                        :pageable="gridOptions.pageable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="gridOptions.groupable"
                        :allow-copy="gridOptions.allowCopy"
                        :column-menu="gridOptions.columnMenu"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :selectable="gridOptions.selectable"
                        :scrollable="gridOptions.scrollable"
                        :editable="true"
                        :dataBound="dataBound">
                <kendo-grid-column :field="'id'"
                                    :filterable="false"
                                    :title="$t('registers.fieldTypes.gridHeaders.id')"
                                    v-html="rawHtml">
                </kendo-grid-column>
                <kendo-grid-column :field="'type'"
                                    :title="$t('registers.fieldTypes.gridHeaders.type')">
                </kendo-grid-column>
                <kendo-grid-column :field="'name'"
                                    :title="$t('registers.fieldTypes.gridHeaders.name')">
                </kendo-grid-column>
                <kendo-grid-column :field="'nameEn'"
                                    :title="$t('registers.fieldTypes.gridHeaders.nameEn')">
                </kendo-grid-column>
                <kendo-grid-column :field="'active'"
                                    :title="$t('registers.fieldTypes.gridHeaders.active')"
                                    :template="activeCellTemplate">
                </kendo-grid-column>
                <kendo-grid-column :template="btnsTemplate"
                                    field="btnsColumn"
                                    :title="$t('actions')"
                                    v-if="showBtns">
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import http from '../../../services/http.service';
    import BtnsTemplate from "../../../components/grid/StandardBtnsTemplate";
    import PageTitle from '../../../components/common/PageTitle';
    import { mapGetters } from 'vuex'

    export default {
        components: { PageTitle },
        props: {
            showBtns: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                componentName: "dynamicRegistersFieldTypes",
                titleKey: 'registers.fieldTypes.title',
                rawHtml: "",
                searchQuery: '',
                defaultGridRows: this.$store.getters.defaultGridRows,
                working: false,
                schemaModelFields: {
                    id: {
                        name: 'id',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.fieldTypes.gridHeaders.id'
                    },
                    type: {
                        name: 'type',
                        type: 'string',
                        validation: { required: true },
                        editable: true,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.fieldTypes.gridHeaders.type'
                    },
                    name: {
                        name: 'name',
                        type: 'string',
                        validation: { required: true },
                        editable: true,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.fieldTypes.gridHeaders.name'
                    },
                    nameEn: {
                        name: 'nameEn',
                        type: 'string',
                        editable: true,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.fieldTypes.gridHeaders.nameEn'
                    },
                    deactivated: {
                        name: 'deactivated',
                        type: 'boolean',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.fieldTypes.gridHeaders.deactivated'
                    },
                    active: {
                        name: 'active',
                        type: 'boolean',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.fieldTypes.gridHeaders.active'
                    }
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/dynamicregistersadministration/listFieldTypes',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    create: {
                        url: this.$store.getters.baseUrl + '/api/dynamicregistersadministration/createFieldType',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    update: {
                        url: this.$store.getters.baseUrl + '/api/dynamicregistersadministration/updateFieldType',
                        dataType: 'json',
                        type: 'PUT',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                }
            }
        },
        methods: {
            dataBound(e) {

            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    this.saveState();
                    return kendo.stringify(options);
                }
            },
            saveState: function () {
                let grid = this.$refs.grid.kendoWidget();

                localStorage["field-types-grid-options"] = kendo.stringify(grid.getOptions());
            },
            loadState: function () {
                let options = localStorage["field-types-grid-options"];
                let grid = this.$refs.grid.kendoWidget();

                if (options) {
                    grid.setOptions(JSON.parse(options));
                }
            },
            toolbarTemplate: function () {
                let templateHtml =
                    '<span>' +
                    '<a class="k-pager-refresh k-link k-button" title="Refresh"><span class="k-icon k-i-reload"></span></a>' +
                    '</span>';

                return kendo.template(templateHtml);
            },
            activeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [{
                            name: "deactivation",
                            text: "",
                            tooltip: this.$t('buttons.deactivate.btnText'),
                            class: 'btn btn-danger',
                            icon: "fas fa-lock",
                            show: this.hasDeleteRights,
                            clickHandler: this.deactivateBtnClick
                        }, {
                            name: 'activation',
                            text: "",
                            tooltip: this.$t('buttons.activate.btnText'),
                            class: 'btn btn-success',
                            icon: "fas fa-lock-open",
                            show: this.hasDeleteRights,
                            clickHandler: this.activateBtnClick
                        }]
                    }
                };
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            deactivateBtnClick(args) {
                if (!this.hasDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                if (!args.active) {
                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: this.$t('buttons.deactivate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.working = true;

                http.delete('/api/dynamicregistersadministration/deactivateFieldType',
                    { params: { id: args.id } }
                ).then((response) => {
                    this.$refs.grid.kendoWidget().dataSource.read();

                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: response.message ? response.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                        text: error.response.data.message
                            ? error.response.data.message
                            : (error.response.data
                                ? error.response.data
                                : (error.response.statusText ? error.response.statusText : error.message)),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            activateBtnClick(args) {
                if (!this.hasDeleteRights) {
                    return this.$router.push(`/unauthorized`);
                }

                if (args.active) {
                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: this.$t('buttons.activate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.working = true;

                http.delete('/api/dynamicregistersadministration/activateFieldType',
                    { params: { id: args.id } }
                ).then((response) => {
                    this.$refs.grid.kendoWidget().dataSource.read();

                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: response.message ? response.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                        text: error.response.data.message
                            ? error.response.data.message
                            : (error.response.data
                                ? error.response.data
                                : (error.response.statusText ? error.response.statusText : error.message)),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            datasorceRequestEnd(e) {
                if (e.type === "create" && e.response) {
                    // 	console.log(e.response[0]);
                    // alert(e.response[0].TaskID);

                    this.$refs.grid.kendoWidget().dataSource.read();
                    this.$vs.notify({
                        title: '',
                        text: e.response && e.response.message ? e.response.message : this.$t('createSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                } else if (e.type === "update" && e.response) {
                    this.$refs.grid.kendoWidget().dataSource.read();
                    this.$vs.notify({
                        title: '',
                        text: e.response && e.response.message ? e.response.message : this.$t('updateSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
        },
        mounted: function () {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            ...mapGetters(['gridOptions']),
            token: function () {
                return this.$store.getters.authToken;
            },
            toolbar: function () {
                return [
                    { name: 'create', text: this.$t('buttons.create.btnText') },
                    { name: 'save', text: this.$t('buttons.save.btnText') },
                    { name: 'cancel', text: this.$t('buttons.reject.btnText') },
                ]
            },
            hasDeleteRights() {
                return this.$store.getters.claims.dynamicRegister.delete;
            },
        }
    }
</script>

<style scoped>
</style>
